import { Rol } from '@src/types/common';

const handleJiraWidget = (): void => {
  const roleId = localStorage.getItem('rolId') ?? '';
  const jiraRolePemissions = [
    Rol.ADMIN.toString(),
    Rol.ADJUSTER.toString(),
    Rol.AUDIT.toString(),
  ];

  const iframe: any = document.getElementById('jsd-widget');
  if (iframe) {
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;
    if (iframeDocument) {
      const display = jiraRolePemissions.includes(roleId) ? 'block' : 'none';
      const buttonContainer = iframeDocument.getElementById('button-container');
      if (buttonContainer) {
        buttonContainer.style.display = display;
      } else {
        iframe.style.display = display;
        console.warn('Jira-Widget :: Button Container not found');
      }
    }
  }
};

export default handleJiraWidget;
